/**
 * Lista de países para el selector "País" de Datos Personales (Settings).
 *
 * Se guarda el NOMBRE en español, no el código ISO: el dato lo consumen humanos
 * (el admin que coordina el pago del premio) y así se lee directo en la DB y en
 * Brands sin tabla de mapeo. Lista curada — toda Hispanoamérica + Brasil + los
 * destinos frecuentes — con 'Otro' como escape; la audiencia es LATAM, no hace
 * falta el ISO-3166 entero. El Select tiene showSearch, así que el largo no molesta.
 */
export const COUNTRIES: string[] = [
  'Argentina',
  'Bolivia',
  'Brasil',
  'Chile',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Ecuador',
  'El Salvador',
  'España',
  'Estados Unidos',
  'Guatemala',
  'Honduras',
  'México',
  'Nicaragua',
  'Panamá',
  'Paraguay',
  'Perú',
  'Puerto Rico',
  'República Dominicana',
  'Uruguay',
  'Venezuela',
  // No-hispanos frecuentes:
  'Alemania',
  'Canadá',
  'Francia',
  'Italia',
  'Portugal',
  'Reino Unido',
  // Escape para el resto del mundo:
  'Otro',
];
